import { Component, inject, Input, OnInit } from '@angular/core';
import { ActiveItemsService } from './active-items.service';
import { Observable } from 'rxjs';
import { InventoryListItem } from '../common/item-list/type';

@Component({
  selector: 'inventory-ui-active-items',
  templateUrl: './active-items.component.html',
  styleUrls: ['./active-items.component.scss'],
  standalone: false,
})
export class ActiveItemsComponent implements OnInit {
  private activeItemsService = inject(ActiveItemsService);

  @Input() partnerId = '';
  @Input() businessId = '';
  @Input() marketId = '';
  @Input() hideTitle = false;

  currentlyActiveItems$!: Observable<InventoryListItem[]>;

  ngOnInit(): void {
    this.currentlyActiveItems$ = this.activeItemsService.getCurrentlyActiveItems(
      this.partnerId,
      this.businessId,
      this.marketId,
    );
  }
}
